
export default {
  data: function () {
    return {
      watchText: '',
      loading: true
    }
  },
  beforeCreate () {
    this.$store.dispatch('watch/watchService').then(
      response => {
        this.watchText = response.data
        this.loading = false
      },
      () => {
        this.loading = false
        this.watchText = 'Overall : KO'
      }
    )
  },
  methods: {
    retour () {
      this.$router.go(-1)
    }
  }
}
